import { rebillClaim } from 'feature/billing/billingSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { Button, Dialog, Stack, Typography } from 'styles';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

interface IReBillingModal {
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	claimNumber: string;
	claimUuid: string;
}

const RebillingModal = ({
	open,
	setOpen,
	claimNumber,
	claimUuid,
}: IReBillingModal) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const dispatch = useDispatch<AppDispatch>();

	const onConfirm = () => {
		setOpen(false);
		dispatch(rebillClaim(claimUuid));
	};

	return (
		<Dialog
			open={open}
			variant="confirm"
			title={tClientLabels('dialog.rebilling.title')}
			close={false}
			events={false}
			actions={null}
			type="rebilling"
		>
			<Typography variant="body">
				{tClientLabels('dialog.rebilling.content', {
					claimNumber,
				})}
			</Typography>

			<Stack direction={'row'} gap={'20px'} justifyContent={'flex-end'} mt={4}>
				<Button variant="outlined" onClick={() => setOpen(false)}>
					{tClientLabels('commons.buttons.cancel')}
				</Button>
				<Button variant="contained" onClick={onConfirm}>
					{tClientLabels('commons.buttons.confirm')}
				</Button>
			</Stack>
		</Dialog>
	);
};

export default RebillingModal;
